const sendMailData = {
    en: {
        title: "Successfully sent!",
        subTitle: "A bottle with your message in it is already on its way to us.",
        desc: "Our crew will review your message and get back to you as soon as possible.",
        button: "Send another",
    },
    ka: {
        title: "წარმატებით გაიგზავნა!",
        subTitle: "ბოთლი თქვენი შეტყობინებით უკვე ჩვენკენ მოემართება.",
        desc: "ჩვენი ეკიპაჟი გაეცნობა თქვენს შეტყობინებას და მალე დაგიკავშირდებათ.",
        button: "სხვა შეტყობინების გაგზავნა",
    },
};

const frabchisingSentData = {
    en: {
        title: "Successfully sent!",
        subTitle: "A bottle with your message in it is already on its way to us. As soon as we get your parchment, we will hurry to answer.",
        button: "Send another",
    },
    ka: {
        title: "წარმატებით გაიგზავნა!",
        subTitle: "ბოთლი თქვენი შეტყობინებით უკვე ჩვენკენ მოემართება. როგორც კი მივიღებთ თქვენს პერგამენტს, სასწრაფოდ გიპასუხებთ.",
        button: "სხვის გაგზავნა",
    },
};

export {
    sendMailData,
    frabchisingSentData
};
